/* Restyles the Amazon MCF / Buy with Prime delivery-promise widgets (Fast Badges)
   to the Toprank brand card design (US Delivery Estimator.html).
   The widgets render inside open shadow roots; page CSS cannot reach them,
   so brand styles are injected into the shadow root itself — the widget's
   markup, data and real-time Amazon delivery dates stay untouched.
   Covers both known widgets:
   - <delivery-promise-container> ("mocca" MCF Fast Badges block: .dpp-entry,
     #ddp-date / #ddp-expiry / #ddp-zipcode-* / .ddp-apply)
   - <delivery-promise-wc> (Buy with Prime component: .AmazonLayout__*) */
(function () {
  var STYLE_ID = 'tl-mcf-brand-styles';
  var MARKERS = '.dpp-entry, .grid-container, #ddp-date, #ddp-zipcode-label-no-expiry, .AmazonLayout__amazon-layout, .PromiseShell__ShopPromise-Shell, .ZipInputForm__LocationWrapper';

  var CSS = [
    /* ============ mocca MCF Fast Badges widget — MINIMAL variant ============ */
    /* (US Delivery Estimator.html turn 2) — no icon box, tighter card,
       "In stock" eyebrow top-left, location top-right, big title, sub line */
    /* flatten the grey box + become a column so ::before eyebrow leads */
    '.dpp-entry{display:block !important;width:100%}',
    '.grid-container{width:100% !important;background:transparent !important;padding:0 !important;border-radius:0 !important;min-width:0 !important;position:relative;display:flex !important;flex-direction:column !important;align-items:flex-start !important}',
    '.fixed-height-grid{min-height:0 !important}',
    /* teal "In stock" eyebrow (top-left) */
    '.grid-container::before{content:"\\2022\\a0 In stock";order:0;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#157f7f;margin-bottom:11px;line-height:1}',
    /* title = "Arrives <date>" (rewritten by transform() below), 19px walnut bold.
       The date part is a separate inner node carrying Amazon's inline color/font
       from the block settings — the `#ddp-date *` rule out-cascades those. */
    '#ddp-date{order:2;margin:0 !important}',
    '#ddp-date,#ddp-date *{font-size:19px !important;font-family:inherit !important;font-weight:700 !important;color:#6b3f2b !important;line-height:1.25 !important}',
    '#ddp-date-fastest-delivery{margin-right:.3em !important}',
    /* sub = countdown line */
    '#ddp-expiry-label{order:3;font-size:12.5px !important;line-height:1.5 !important;color:#6b6b6b !important;margin-top:2px !important}',
    '#ddp-expiry,#ddp-expiry.green{color:#b76e3c !important;font-weight:600;font-size:12.5px !important}',
    /* status colors: Amazon green/red → brand teal / muted red */
    '.green{color:#157f7f !important}',
    '.red{color:#a94442 !important}',
    /* location row → plain "82801 · Sheridan, WY" pinned top-right (design 2B):
       no pin icon, no "Deliver to" prefix, no chevron; city is appended by the
       transform() below, the hidden chevron is triggered by our Change button */
    '#ddp-zipcode-label,#ddp-zipcode-label-no-expiry{position:absolute !important;top:0;right:0;left:auto !important;width:auto !important;max-width:65%;padding:0 !important;margin:0 !important;font-size:12px !important;font-weight:500 !important;color:#6b6b6b !important;line-height:1;display:flex;align-items:center;justify-content:flex-end;text-align:right}',
    '.geopin-container{display:none !important}',
    '.chevron-button{display:none !important}',
    '.ddp-zipcode{color:#6b6b6b !important;font-weight:500 !important;text-decoration:none !important}',
    '.underlined-text{text-decoration:none !important}',
    '.tl-city{color:#6b6b6b;white-space:pre}',
    /* done row: check + shipping method + Change (design 2B bottom row) */
    '.tl-done{order:4;display:flex;align-items:center;gap:8px;width:100%;font-size:13px;color:#6b6b6b;margin-top:14px}',
    '.tl-done svg{flex:none;width:16px;height:16px;color:#6b7050;fill:none}',
    '.tl-chg{margin-left:auto;background:none !important;border:none !important;padding:0 !important;font-size:12px !important;font-weight:600 !important;color:#b76e3c !important;cursor:pointer;min-height:0 !important;line-height:1 !important}',
    '.tl-chg:hover{color:#6b3f2b !important}',
    /* while the ZIP form is expanded, the done row steps aside */
    '.grid-container:has(#ddp-zipcode-input) .tl-done{display:none}',
    /* ZIP input row flows full-width at the bottom when expanded */
    '.input-zipcode-grid{order:5;width:100%;margin-top:12px !important}',
    '#ddp-zipcode-input,input{height:44px !important;min-height:44px !important;border:1.5px solid #e6e0d8 !important;border-radius:9px !important;background:#fff !important;font-size:14px !important;color:#1a1a1a !important;box-shadow:none !important}',
    '#ddp-zipcode-input{padding:0 0 0 14px !important}',
    '#ddp-zipcode-input:focus{border:1.5px solid #b76e3c !important}',
    /* Apply button */
    '.ddp-apply button{background-color:#6b3f2b !important;color:#f5f1eb !important;border:none !important;border-radius:9px !important;height:44px !important;line-height:1 !important;padding:2px 24px !important;font-size:14px !important;font-weight:700 !important;letter-spacing:.02em}',
    '.ddp-apply button:hover{background-color:#4b2816 !important}',
    '.ddp-apply button:active{background-color:#4b2816 !important}',
    '.ddp-apply button:disabled{background-color:#6b3f2b !important;opacity:.5}',
    '.ddp-apply button:disabled:hover{background-color:#6b3f2b !important}',
    '.ddp-apply:focus{border:1px solid #b76e3c !important;border-radius:9px}',
    '.ddp-apply:focus button{background-color:#4b2816 !important}',
    '.error-message{color:#a94442 !important;font-size:12px}',
    '.ddp-zipcode-errormessage{color:#a94442 !important}',

    /* ============ Buy with Prime web component (delivery-promise-wc) ============ */
    ':host{--p-surface-button:#6b3f2b !important;--p-color-button-text:#f5f1eb !important;--p-surface-focus-color:#b76e3c !important;--p-color-text-secondary:#6b6b6b !important;--p-color-input-text:#1a1a1a !important;--p-border-input:1.5px solid #e6e0d8 !important;--p-border-input-focus:1.5px solid #b76e3c !important;--p-border-radius-100:9px !important;--p-border-radius-125:9px !important;--p-border-radius-200:9px !important;--p-text-body-sm-font-size:12.5px !important;--p-text-body-md-font-size:13px !important;--p-text-heading-lg-font-size:19px !important}',
    '.AmazonLayout__amazon-layout .AmazonLayout__title-line{font-size:19px !important;font-weight:700 !important;color:#1a1a1a !important}',
    '.Text__Text.Text__subdued{color:#6b6b6b !important;font-size:12.5px !important}',
    '.ZipInputForm__LocationWrapper{font-size:12px !important;color:#6b6b6b !important}',
    '.ZipInputForm__LocationEdit{color:#b76e3c !important;font-weight:600 !important;background:transparent !important;border:none !important;cursor:pointer}',
    '.Button__button{background:#6b3f2b !important;color:#f5f1eb !important;border:none !important;border-radius:9px !important;font-weight:700 !important}',
    '.Button__button:hover{background:#4b2816 !important}'
  ].join('\n');

  var roots = new Set();
  var queued = false;
  var observer = new MutationObserver(schedule);

  function inject(root) {
    if (root.querySelector('#' + STYLE_ID)) return true;
    if (!root.querySelector(MARKERS)) return false;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
    var host = root.host;
    if (host) {
      var block = host.closest && host.closest('.shopify-app-block');
      if (block) block.classList.add('tl-mcf-card');
    }
    return true;
  }

  /* Live seconds countdown: Amazon renders the cutoff as static
     "Order within 16 hrs 50 mins" — anchor to that value (or to the exact
     deliverypromiseexpiry timestamp when the widget exposes one) and tick
     the same sentence down every second. If Amazon rewrites the line
     (zip/variant change), the ticker re-anchors to the new value. */
  var TIME_RE = /(\d+)\s*hrs?\s+(\d+)\s*mins?|(\d+)\s*mins?/;

  function fmt(ms) {
    if (ms < 0) ms = 0;
    var h = Math.floor(ms / 36e5);
    var m = Math.floor((ms % 36e5) / 6e4);
    var s = Math.floor((ms % 6e4) / 1000);
    var out = '';
    if (h > 0) out += h + (h === 1 ? ' hr ' : ' hrs ');
    if (h > 0 || m > 0) out += m + (m === 1 ? ' min ' : ' mins ');
    return out + s + (s === 1 ? ' sec' : ' secs');
  }

  function setupTicker(root) {
    var el = root.querySelector('#ddp-expiry');
    if (!el || el.__tlTick) return;
    var text = el.textContent || '';
    var match = TIME_RE.exec(text);
    if (!match) return;

    var target = null;
    var props = root.querySelector('#mocca-page-props');
    if (props) {
      try {
        var v = JSON.parse(props.textContent).deliverypromiseexpiry;
        if (v && v !== 'null') {
          var t = isNaN(v) ? Date.parse(v) : (+v > 1e12 ? +v : +v * 1000);
          if (t && t > Date.now()) target = t;
        }
      } catch (e) {}
    }
    if (!target) {
      var h = parseInt(match[1] || 0, 10);
      var m = parseInt(match[2] || match[3] || 0, 10);
      target = Date.now() + (h * 3600 + m * 60 + 59) * 1000;
    }

    var prefix = text.slice(0, match.index);
    var suffix = text.slice(match.index + match[0].length);
    el.__tlTick = true;
    var last = '';

    function tick() {
      if (!el.isConnected) { clearInterval(iv); return; }
      if (last !== '' && el.textContent !== last) {
        /* Amazon rewrote the line — restart from the fresh value */
        clearInterval(iv);
        el.__tlTick = false;
        setupTicker(root);
        return;
      }
      var ms = target - Date.now();
      last = prefix + fmt(ms) + suffix;
      el.textContent = last;
      if (ms <= 0) clearInterval(iv);
    }
    var iv = setInterval(tick, 1000);
    tick();
  }

  /* Minimal-variant DOM pass (design 2B) — reshuffles Amazon's own data, adds
     nothing that isn't theirs: the method prefix ("Standard Delivery") moves
     from the date line to a bottom "✓ method · Change" row so the title reads
     "Arrives <date>", and the bare ZIP gets its city/state appended (resolved
     via zippopotam.us, cached). Amazon re-renders are re-transformed by the
     MutationObserver; every mutation here is guarded so the observer loop
     settles. */
  function transform(root) {
    var grid = root.querySelector('.grid-container');
    if (!grid) return;

    /* title: "<b>Standard Delivery</b> Friday, Jul 17" → "Arrives Friday, Jul 17" */
    var method = root.querySelector('#ddp-date-fastest-delivery');
    if (method) {
      var m = (method.textContent || '').trim();
      if (m && m !== 'Arrives') {
        root.__tlMethod = m;
        method.textContent = 'Arrives';
      }
    }

    /* bottom row: ✓ <method> ...... Change */
    if (root.querySelector('#ddp-date') && root.__tlMethod) {
      var done = grid.querySelector('.tl-done');
      if (!done) {
        done = document.createElement('div');
        done.className = 'tl-done';
        done.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg><span class="tl-done-txt"></span><button type="button" class="tl-chg">Change</button>';
        done.querySelector('.tl-chg').addEventListener('click', function () {
          var chevron = root.querySelector('.chevron-button');
          if (chevron) chevron.click();
        });
        grid.appendChild(done);
      }
      var txt = done.querySelector('.tl-done-txt');
      if (txt.textContent !== root.__tlMethod) txt.textContent = root.__tlMethod;
    }

    /* location: "82801" → "82801 · Sheridan, WY" */
    var zipEl = root.querySelector('.ddp-zipcode');
    if (zipEl) {
      var zip = (zipEl.textContent || '').trim();
      if (/^\d{5}$/.test(zip)) {
        var city = zipEl.parentElement.querySelector('.tl-city');
        if (!city) {
          city = document.createElement('span');
          city.className = 'tl-city';
          zipEl.insertAdjacentElement('afterend', city);
        }
        if (city.dataset.zip !== zip) {
          city.dataset.zip = zip;
          city.textContent = '';
          var key = 'tl_usde_city_' + zip;
          var cached = null;
          try { cached = localStorage.getItem(key); } catch (e) {}
          if (cached) {
            city.textContent = ' · ' + cached;
          } else {
            fetch('https://api.zippopotam.us/us/' + zip)
              .then(function (res) { return res.ok ? res.json() : null; })
              .then(function (d) {
                if (d && d.places && d.places[0]) {
                  var c = d.places[0]['place name'] + ', ' + d.places[0]['state abbreviation'];
                  try { localStorage.setItem(key, c); } catch (e) {}
                  if (city.dataset.zip === zip) city.textContent = ' · ' + c;
                }
              })
              .catch(function () {});
          }
        }
      }
    }
  }

  function maintain(root) {
    inject(root);
    transform(root);
    setupTicker(root);
  }

  function track(root) {
    if (!root || roots.has(root)) return;
    roots.add(root);
    observer.observe(root, { childList: true, subtree: true });
    maintain(root);
  }

  function sweep() {
    document.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) track(el.shadowRoot);
    });
    roots.forEach(maintain);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      roots.forEach(maintain);
    });
  }

  if (Element.prototype.attachShadow) {
    var originalAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      var root = originalAttachShadow.call(this, init);
      try { if (init && init.mode === 'open') track(root); } catch (e) {}
      return root;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep, { once: true });
  } else {
    sweep();
  }
  window.addEventListener('load', sweep);
})();
